import { Grid, TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import { SignUpFieldProps } from "./model";

const CompanyFields = ({ userData, setUserData }: SignUpFieldProps) => (
  <>
    <Grid item xs={12} md={12}>
      <FormControl fullWidth sx={{ m: 1 }}>
        <TextField
          id="outlined-basic3"
          label="Название организации или ФИО"
          variant="outlined"
          onChange={(e) => {
            setUserData({
              ...userData,
              company: e.target.value,
            });
          }}
          value={userData.company}
        />
      </FormControl>
    </Grid>
    <Grid item xs={12} md={12}>
      <FormControl fullWidth sx={{ m: 1 }}>
        <TextField
          id="outlined-basic3"
          label="Город нахождения компании"
          variant="outlined"
          onChange={(e) => {
            setUserData({
              ...userData,
              city: e.target.value,
            });
          }}
          value={userData.city}
        />
      </FormControl>
    </Grid>
  </>
);

export default CompanyFields;
